"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInterval = void 0;
var TimeInterval;
(function (TimeInterval) {
    TimeInterval[TimeInterval["xs"] = 1000] = "xs";
    TimeInterval[TimeInterval["sm"] = 5000] = "sm";
    TimeInterval[TimeInterval["md"] = 10000] = "md";
    TimeInterval[TimeInterval["lg"] = 60000] = "lg";
    TimeInterval[TimeInterval["xl"] = 300000] = "xl";
    TimeInterval[TimeInterval["xxl"] = 600000] = "xxl";
})(TimeInterval = exports.TimeInterval || (exports.TimeInterval = {}));
//# sourceMappingURL=queryTypes.js.map